const Joi = require("joi");

const additionalResourceSchema = (data) => {
  const schema = Joi.object({
    title: Joi.string().trim().required().messages({
      "string.empty": "Please enter Title.",
      "any.required": "Please enter Title.",
    }),
    url: Joi.string().trim().required().messages({
      "string.empty": "Please enter Title.",
      "any.required": "Please enter Title.",
    }),
    committee: Joi.string().trim().required().messages({
      "string.empty": "Please enter Title.",
      "any.required": "Please enter Title.",
    }),
    // photo: Joi.string()
    //   .trim()
    //   .pattern(/^data:image\/(jpeg|png|webp);base64,[A-Za-z0-9+/=]+$/)
    //   .required()
    //   .messages({
    //     "string.pattern.base": "Invalid image format. Must be base64 encoded.",
    //     "string.empty": "Photo is required.",
    //     "any.required": "Photo is required.",
    //   }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

module.exports = additionalResourceSchema;
